import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import Stack  from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function UserProfile(){
    return(
        <div>
            <Typography>User Profile</Typography>
        </div>
    );
}